import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { Observable, map } from "rxjs";
import { ParametresService } from "src/app/shared/services/parametres.service";

export const NousJoindreResolver: ResolveFn<string> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  valeurParametreService = inject(ParametresService)
): Observable<string> => valeurParametreService.obtenirValeur('COURRIER_SUPP_PUBLIC').pipe(
  map(rep => rep.valeur),
);
export const NousJoindrePublicResolver: ResolveFn<string> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  valeurParametreService = inject(ParametresService)
): Observable<string> => valeurParametreService.obtenirValeur('COURRIER_SUPP_PUBLIC').pipe(
  map(rep => rep.valeur),
);
